<template>
    <paper class="receiptReviewManage">
        <mPane
            ref="tablePage"
            :config="config"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :currentPage="searchParams.pageNo"
            @searchChange="searchChange"
            @selectChange="selectChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            >
        </mPane>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import config from './config.js';
import api from '../../api/revocationCarrierHistory.js';
import common from '../../common/common.js';
import { maxDay } from '@/modules/transport/tms/common/common';
import dayjs from 'dayjs';
import { mapState } from 'vuex';

export default {
    components: { paper, mPane },
    data() {
        return {
            config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            checkedData: [], // 已选中数据
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                ettaCarrierEbcuCode: ''
            }
        };
    },
    methods: {
        // 获取撤回类型
        async getOptions() {
            if (!JSON.parse(localStorage.getItem('SYS_TMS_REASON_TYPE'))) {
                await common._getDictionaryDetailByCode('SYS_TMS_REASON_TYPE').then(res => {
                    if (res) {
                        localStorage.setItem('SYS_TMS_REASON_TYPE', JSON.stringify(res.SYS_TMS_REASON_TYPE));
                    }
                });
            }
            const SYS_TMS_REASON_TYPE = JSON.parse(localStorage.getItem('SYS_TMS_REASON_TYPE'));
            Object.entries(SYS_TMS_REASON_TYPE).forEach(item => {
                this.config.searchList.searchTxt[2].options.push({
                    value: item[0],
                    label: item[1]
                });
            });
        },
        selectChange(data) {
            this.checkedData = data;
        },
        pageChange(pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getTableList();
        },
        sizeChange(pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getTableList();
        },
        searchChange(data) {
            const createTime = data.createTime || [];
            this.searchParams.pageNo = 1;
            this.searchParams = {
                ...this.searchParams,
                ...data,
                createTimeFrom: createTime[0] && dayjs(createTime[0]).format('YYYY-MM-DD HH:mm:ss'),
                createTimeTo: createTime[1] && dayjs(createTime[1]).format('YYYY-MM-DD HH:mm:ss')
            };
            delete this.searchParams.createTime;
            this.getTableList();
        },
        _validateSearchParams(data) {
            if (!data.createTimeFrom) {
                return '撤回时间不能为空！';
            }
            const beginDate = dayjs(data.createTimeFrom).valueOf() || 0;
            const endDate = dayjs(data.createTimeTo).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            if (differenceValue > maxDay) {
                return '按时间查询时，时间跨度不可超过一个月！';
            }
        },
        getTableList() {
            const msg = this._validateSearchParams(this.searchParams);
            if (msg) return this.$message.warning(msg);
            this.loading = true;
            api.queryWithdrawReport(this.searchParams).then(res => {
                if (res) {
                    if (res.data.totalPage !== 0 && this.searchParams.pageNo > res.data.totalPage) {
                        this.searchParams.pageNo = res.data.totalPage;
                        this.getTableList();
                        return false;
                    }
                    setTimeout(() => {
                        res.data.list.forEach(item => {
                            item.ettaRecallReasonTypeName = localStorage.SYS_TMS_REASON_TYPE ? (JSON.parse(localStorage.SYS_TMS_REASON_TYPE))[item.ettaRecallReasonType] : item.ettaRecallReasonType;
                        });
                        this.totalData = res.data.list;
                    }, 100);
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.searchParams.ettaCarrierEbcuCode = this.user.userCode.toLocaleUpperCase();
        // 获取首页列表数据 手动触发搜索，取默认值进行搜索
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    created () {
        // 获取撤回类型
        this.getOptions();
    }
};
</script>
